import React, { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Badge, Checkbox, Text, useTheme } from '@Sage/hoi-poi-ui';

import { getLiteral } from 'utils/getLiteral';

import { LEADS_PREVIEW_CHECKBOX_COL_ID, LEADS_PREVIEW_ENTITY } from './constants';
import { LEADS_LITERALS } from './literals';

const LeadPreviewRow = ({ data = {}, colDef }) => {
    const theme = useTheme();
    const colId = colDef?.colId || LEADS_PREVIEW_CHECKBOX_COL_ID;
    const entityKey = LEADS_PREVIEW_ENTITY.entity;
    const rowId = data?.id;

    const selected = useSelector((state) => {
        const rows = state.entityListSelect?.[entityKey]?.checkedWeb5?.[colId]?.rows;
        if (!rows || rowId === undefined || rowId === null) return false;
        return Boolean(rows[rowId] ?? rows[String(rowId)]);
    });

    const onToggleLead = colDef?.cellRendererParams?.onToggleLead;

    const handleRowClick = useCallback(() => {
        onToggleLead?.(data, !selected);
    }, [data, onToggleLead, selected]);

    const handleSelectionClick = useCallback(
        (event) => {
            event.stopPropagation();
            onToggleLead?.(data, !selected);
        },
        [data, onToggleLead, selected],
    );

    return (
        <div className="fm-leads-preview-row" onClick={handleRowClick}>
            <div className="fm-leads-preview-row__leading">
                <div
                    className="fm-leads-preview-row__selection"
                    onClick={handleSelectionClick}
                    role="presentation"
                >
                    <Checkbox
                        className="fm-leads-preview-row__checkbox"
                        color="actionMajor"
                        checked={selected}
                        onChange={() => {}}
                    />
                </div>
                <div className="fm-leads-preview-row__main">
                    <Text
                        type="subtitle"
                        medium
                        isTruncated
                        useTooltip
                        className="fm-leads-preview-row__truncate"
                    >
                        {data.name}
                    </Text>
                    <Text
                        type="caption"
                        color={theme.colors.utility.textSecondary}
                        isTruncated
                        useTooltip
                        className="fm-leads-preview-row__truncate"
                    >
                        {data.category || '-'}
                    </Text>
                </div>
                <div className="fm-leads-preview-row__status">
                    {data.potential_duplicate && (
                        <Badge type="caution">
                            {getLiteral(LEADS_LITERALS.potentialDuplicate)}
                        </Badge>
                    )}
                </div>
            </div>
            <div className="fm-leads-preview-row__distance">
                <Text
                    type="caption"
                    color={theme.colors.utility.textSecondary}
                    isTruncated
                    useTooltip
                    className="fm-leads-preview-row__truncate"
                >
                    {getLiteral(LEADS_LITERALS.distanceFromOrigin)}
                </Text>
                <Text
                    type="subtitle"
                    medium
                    isTruncated
                    useTooltip
                    className="fm-leads-preview-row__truncate"
                >
                    {data.distanceLabel || '-'}
                </Text>
            </div>
        </div>
    );
};

export default memo(LeadPreviewRow);
